import { defineAction } from '~/prix'
import { z } from 'zod'
import creditSoldProductUpdateAction from './creditSoldProductUpdate.action.json' with { type: 'json' }
import { creditSoldProductUpdateInputObject } from '../creditSoldProductObject'

const creditSoldProductUpdateDefinition = defineAction({
  ...creditSoldProductUpdateAction,

  input: creditSoldProductUpdateInputObject,
  output: z.object({}),
})

export default creditSoldProductUpdateDefinition

